import React from 'react';
import IProjectContact from '../../../util-api/models/projectContact';
import FilevineIcon from '../../FilevineIcon';
import ContactDetails from '../ContactDetails';
import GenericCard from '../GenericCard';
import Persona, { getInitials } from '../Persona';

const css = require('./ContactPreview.module.scss');

interface IContactPreviewProps {
  projectContact: IProjectContact,
  clickable?: boolean,
  onRefresh?: () => void,
}
const ContactPreview = ({ projectContact, clickable = false, onRefresh }: IContactPreviewProps) => {
  const ProjectHeaderPreview = (
    <div className={css.projectHeaderContainer}>
      <div className={css.projectHeaderPersonaContainer}>
        <GenericCard
          buttonIcon={<Persona
            avatarUrl={projectContact?.orgContact?.pictureUrl}
            initials={getInitials(projectContact?.orgContact?.fullName)}
            large
        />}
      child={<ContactDetails projectContact={projectContact} />}
      outlined={false}
      genCardButtonClass={css.projectHeaderPersona}
      onOpen={onRefresh}
    />
      </div>
      <div className={css.projectHeaderText}>
        <GenericCard
          child={<ContactDetails projectContact={projectContact} />}
          outlined={false}
          buttonTitle={`${projectContact?.orgContact?.firstName || ''} ${projectContact?.orgContact?.lastName || ''}`}
          buttonText={`${projectContact?.orgContact?.firstName || ''} ${projectContact?.orgContact?.lastName || ''}`}
          genCardButtonClass={css.projectHeaderFullname}
          onOpen={onRefresh}
        />
      {projectContact?.orgContact?.primaryEmail && (
        <div className={css.projectHeaderEmail}>
          {projectContact?.orgContact?.primaryEmail || ''}
        </div>
      )}
      </div>
  </div>
);

const ContactListPreview = (
<div className={css.container}>
<div className={css.persona}>
  <Persona
    avatarUrl={projectContact?.orgContact?.pictureUrl}
    initials={getInitials(projectContact?.orgContact?.fullName)}
  />
</div>
<div className={css.text}>
  <div className={css.fullname}>
    {projectContact?.orgContact?.fullName || ''}
  </div>
  {projectContact?.orgContact?.primaryEmail && (
        <div className={css.email}>
          {projectContact?.orgContact?.primaryEmail || ''}
        </div>
      )}
      {projectContact?.orgContact?.phones?.length > 0 && (
        <div className={css.phone}>
          {projectContact?.orgContact?.phones[0]?.number || ''}
        </div>
      )}
    </div>
    <div className={css.cardButton}>
      <GenericCard
        child={<ContactDetails projectContact={projectContact} />}
        buttonIcon={<FilevineIcon icon="chevron-right" />}
        outlined={false}
        onClose={onRefresh}
      />
    </div>
  </div>
);

return (clickable ? ProjectHeaderPreview : ContactListPreview);
};



export default ContactPreview;
